import React from 'react';
import {useTranslation} from 'react-i18next';

import {classyArray} from '@ELib/utilities/HelperFunctions';

import {BaseButton, BaseButtonProps, ButtonProps} from './BaseButton';
import {StyledSmallButton} from './ButtonElements';

const BaseESmallButton = (props: BaseButtonProps) => (
  <BaseButton
    type='button'
    {...props}
    ButtonElement={StyledSmallButton}
    className={classyArray(['ESmallButton', props.className])}
  />
);

//#region Default SmallButton
export const ESmallButton = (props: ButtonProps): React.ReactElement => (
  <BaseESmallButton {...props} />
);
//#endregion

//#region Danger SmallButton
export const ESmallDangerButton = (props: ButtonProps): React.ReactElement => (
  <BaseESmallButton {...props} variant='danger' />
);

export const ESmallDeleteButton = (
  props: Omit<ButtonProps, 'children'>
): React.ReactElement => {
  const {t} = useTranslation('lib');
  return (
    <ESmallDangerButton {...props}>{t('actions.delete')}</ESmallDangerButton>
  );
};
//#endregion
